import { useContext } from 'react';
import { FormContext, FormContextValues } from '../providers/FormProvider';

function useForm() {
  return useContext(FormContext) as FormContextValues;
}

export default useForm;
